import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class DPTransactionSubmitUseCase extends BaseUseCase {
    constructor(dpTransactionRepo) {
        super();
        this.dpTransactionRepo = dpTransactionRepo;
    }
    async fetchResult(requestData) {
        return await this.dpTransactionRepo.submitSpecificRequest(requestData);
    }
}
export default DPTransactionSubmitUseCase;
